module.exports = __webpack_public_path__ + "static/media/kibana.69caefed.svg";